module.exports = __webpack_public_path__ + "img/minecraft_programming_for_children2.8b759ecf.jpg";